module.exports = __webpack_public_path__ + "static/58-11e6cf4c99918422fb1259dcc8c53cee.jpg";